// captcha_sign 文档
// https://md.office.k8s.xunlei.cn/DBdqxXjlQb29tq4ZcSDJ5Q?view
// node环境中运行，commonjs


import axios from 'axios'
import md5 from 'blueimp-md5'
import { SSOconfig } from './config'
import pkg from '../../package'


const { clientId, packageName, signKey, algVersion } = SSOconfig
const getPubKeyTimeStamp = parseInt(Date.now() / 1000)

// 获取最初pub_key
async function getPubKey () {
  const sign = md5(`${clientId}${pkg.version}${packageName}${getPubKeyTimeStamp}${algVersion}${signKey}`)
  // console.log('1.-----sign :>> ', sign);
  return axios.get(
    `https://risk-account-ssl.office.k8s.xunlei.cn/amaze/v1.0/algorithms?client_id=${clientId}&client_version=${pkg.version}&package_name=${packageName}&timestamp=${getPubKeyTimeStamp}&alg_version=${algVersion}&sign=${sign}`,
  )
    .then(res => {
      return res.data
    })
    .catch(err => Promise.reject(err.response.data))
}

export default getPubKey
